export default {"src":"/_next/static/media/Comprehensive Treatment Options.4d204fe4.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};